import { IUserSession } from '../../../helpers/user-session'

import { MapController } from './map.controller'
import { SystemService, SYSTEM_SERVICE_NAME } from '../../../services/system'

//#region Asset Imports

import './map.scss'
import * as TEMPLATE from './map.tpl.html'

//#endregion

export class MapDirective implements ng.IDirective {

    scope = {
        data: '=',
        itemTitle: '=',
        fitToScreen: '=?',
        isEditMode: '='
    }

    controller = [
        '$scope',
        '$q',
        '$timeout',
        'userSession',
        SYSTEM_SERVICE_NAME,
        (
            $scope,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            userSession: IUserSession,
            systemService: SystemService
        ) => new MapController($scope, $q, $timeout, userSession, systemService)]

    restrict = 'E'
    template = TEMPLATE
    transclude = true
    replace = true
}